
import dayjs from 'dayjs'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'RequestedOrdersCard',

  computed: {
    ...mapState('transact', ['orders', 'customer']),
  },

  async created() {
    if (!this.customer) {
      await this.setCustomer()
    }

    await this.setOrders()
  },

  methods: {
    dayjs,
    ...mapActions('transact', ['setCustomer', 'setOrders']),
  },
}
